<template>
  <div class="noticias">
    <h3 class="title text-center">Ultimas Noticias</h3>
    <br>
    <div class="container">
      <div class="row">
        <div class="col-md-4 align-center" v-for="x in list" v-bind:key="x.uuid">
          <div class="card card-plain card-blog">
            <div class="card-image align-center">
              <a :href="x.postEntryUrl">
                <div
                  class="thumbnail img rounded img-raised"
                  :style="getImageAttribute(x.thumbImageUrl)"
                ></div>
                <!-- <img class="img rounded img-raised thumbnail" :src="x.thumbImageUrl"> -->
              </a>
            </div>
            <div class="card-body">
              <h6 class="category text-info">
                <i class="now-ui-icons media-2_sound-wave"></i>
                {{x.daysPassed}}
              </h6>
              <h4 class="card-title">
                <a :href="x.postEntryUrl">{{x.title}}</a>
              </h4>
              <p class="card-description">
                {{x.content}}
                <a :href="x.postEntryUrl">Leer mas...</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 ml-auto mr-auto">
          <div class="submit text-center">
            <a href="#/noticias" class="btn btn-primary btn-round mt-4 btn-lg" round>Ver Todas</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components";

export default {
  name: "ultimas-noticias-home",
  components: { Card },
  data() {
    return {
      list: []
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    load: async function() {
      try {
        let response = await this.$zaiq().get("Noticia/Lastest", {
          params: {
            take: 3
          }
        });

        this.list = response.data.result.items;
      } catch (e) {
        if (this.vErrors) this.vErrors.items.push(e);
        console.log(e);
      }
    },
    getImageAttribute: function(url) {
      return "background-image: url(" + url + ");";
    }
  }
};
</script>
<style>
.thumbnail {
  /* https://stackoverflow.com/questions/27460065/how-to-make-same-sized-thumbnails */
  background-color: black;
  width: 300px;
  height: 200px;
  display: inline-block; /* makes it fit in like an <img> */
  background-size: cover; /* cover or contain */
  background-position: center center;
  background-repeat: no-repeat;
}
.align-center {
  text-align: center;
}
</style>